import Vue from 'vue';
import i18n from '@/i18n';
const vue = new Vue({i18n});

export const IMMIGRANT = "IMMIGRANT";
export const ASCENDANT = "ASCENDANT";
export const APPLICANT = "APPLICANT";
export const ALMOST_18 = "ALMOST_18";
export const UNDER_AGE = "UNDER_AGE";

export const CATEGORY_OF_CERTIFICATES = [
    {id: IMMIGRANT, name: vue.$t('enumerations.category-of-certificates.immigrant')},
    {id: ASCENDANT, name: vue.$t('enumerations.category-of-certificates.ascendant')},
    {id: APPLICANT, name: vue.$t('enumerations.category-of-certificates.applicant')},
    {id: ALMOST_18, name: vue.$t('enumerations.category-of-certificates.almost_18')},
    {id: UNDER_AGE, name: vue.$t('enumerations.category-of-certificates.under_age')},
];

export default {
    
    getCategoryCertificateName(categoryCertificateId) {
        let categoryLabel = "";
        CATEGORY_OF_CERTIFICATES.forEach(categoryCertificate => {
           if(categoryCertificate.id === categoryCertificateId){
            categoryLabel = categoryCertificate.name;
           }
        });
        return categoryLabel;
    }

}
